(() => {
  const SELECTOR = '[data-starco-global-header]';

  function initHeader(root) {
    if (!root || root.dataset.starcoHeaderReady === 'true') return;
    root.dataset.starcoHeaderReady = 'true';

    const drawer = root.querySelector('#starco-mobile-drawer');
    const openButton = root.querySelector('[data-starco-drawer-open]');
    const closeButtons = [...root.querySelectorAll('[data-starco-drawer-close]')];
    const accordionButtons = [...root.querySelectorAll('[data-starco-accordion]')];
    let lastFocused = null;

    function getFocusable() {
      if (!drawer) return [];
      return [...drawer.querySelectorAll('a[href], button:not([disabled])')]
        .filter((element) => element.offsetParent !== null);
    }

    function setOpen(isOpen) {
      if (!drawer || !openButton) return;
      root.classList.toggle('is-drawer-open', isOpen);
      document.documentElement.classList.toggle('starco-drawer-open', isOpen);
      document.body.classList.toggle('starco-drawer-open', isOpen);
      drawer.setAttribute('aria-hidden', String(!isOpen));
      openButton.setAttribute('aria-expanded', String(isOpen));
      openButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');

      if (isOpen) {
        lastFocused = document.activeElement;
        window.requestAnimationFrame(() => drawer.querySelector('[data-starco-drawer-close]')?.focus());
      } else {
        accordionButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (panel) panel.hidden = true;
        });
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }
    }

    openButton?.addEventListener('click', () => {
      setOpen(!root.classList.contains('is-drawer-open'));
    });
    closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));

    accordionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(willOpen));
        button.setAttribute('aria-label', `${willOpen ? 'Hide' : 'Show'} ${button.closest('.starco-mobile-menu__group')?.querySelector('a')?.textContent.trim() || 'menu'} links`);
        panel.hidden = !willOpen;
      });
    });

    drawer?.addEventListener('click', (event) => {
      if (event.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (!root.classList.contains('is-drawer-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(false);
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = getFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 900 && root.classList.contains('is-drawer-open')) setOpen(false);
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
